import 'babel-polyfill';
import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from 'routes';
import MainLayout from 'views/layouts/main';
import initializer from 'initializer';
import 'bootstrap';

Vue.use(VueRouter);

let router = new VueRouter({ routes, linkActiveClass: 'active' });

initializer(router);

new Vue({
	router,
	render(h) {
		return h(MainLayout);
	}
}).$mount('#application-container');


// WEBPACK FOOTER //
// ./application/main.js